/** Medium Tracking */
export function setMediumParam() {
    if (!window.isRealUser) {
        return;
    }

    const links = document.querySelectorAll('a[data-medium]');
    links.forEach(link => {
        const mediumParam = `m=${link.getAttribute('data-medium')}`;
        if (
            typeof link.href === 'string' &&
            !link.href.includes('?m=') &&
            !link.href.includes('&m=')
        ) {
            // eslint-disable-next-line no-param-reassign
            link.href = link.href.concat(
                link.href.includes('?') ? `&${mediumParam}` : `?${mediumParam}`,
            );
        } else if (
            link.href.baseVal &&
            !link.href.baseVal.includes('?m=') &&
            !link.href.baseVal.includes('&m=')
        ) {
            // eslint-disable-next-line no-param-reassign
            link.href.baseVal = link.href?.baseVal.concat(
                link.href?.baseVal.includes('?') ? `&${mediumParam}` : `?${mediumParam}`,
            );
        }
    });
}
/** END Medium Tracking */
